import { ButtonTertiary } from "components/Atoms/Button";
import React from "react";
import { getUpdateInvoiceV1DetailsInstruction } from "utilities/invoiceUtils";

interface Props {
  invoice: server.dto.InvoiceV1
  onConverted: () => Promise<any>
}

export const ConvertToProforma = (props: Props) => {
  const [hasPressedUpdate, setHasPressedUpdate] = React.useState(false);
  const [error, setError] = React.useState<string>(null);

  const changeProformaToInvoice = async () => {
    setHasPressedUpdate(true);
    try {
      const res = await window.CoreApi.Invoice.Update({
        ...getUpdateInvoiceV1DetailsInstruction(props.invoice),
        isDraft: false,
      });
      if (res.data.hasErrors) {
        setError(res.data.errors[0].message);
        setHasPressedUpdate(false);
        return;
      }
    } catch {
      setError(RESX.GeneralLabels.SomethingUnexpectedHappened);
      setHasPressedUpdate(false);
      return;
    }

    props.onConverted();
  }

  if (props.invoice.permissions.canModify) {
    return <div className="flex-column gap">
      <div>
        <ButtonTertiary
          onClick={changeProformaToInvoice}
          label={RESX.Invoice.ConvertToInvoice}
          loading={hasPressedUpdate}
          disabled={hasPressedUpdate}
        />
      </div>
      {error && <div className="ui message red">
        {error}
      </div>}
    </div>
  }

  return <div>{RESX.Document.ProForma}</div>;
}